/* ==========================================================================
   Herbstlaub im Hero: erzeugt wenige Blätter mit zufälliger Position, Größe und
   Geschwindigkeit. Start erst, wenn der Browser Luft hat; pausiert, solange der
   Hero nicht sichtbar ist. Bei „Bewegung reduzieren“ passiert nichts.
   ========================================================================== */
(() => {
  'use strict';

  if (customElements.get('herbst-laub')) return;

  const rand = (min, max) => min + Math.random() * (max - min);

  class HerbstLaub extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const urls = (this.dataset.leaves || '').split('|').filter(Boolean);
      if (!urls.length) return;

      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const count = Number(mobile ? this.dataset.countMobile : this.dataset.count) || (mobile ? 4 : 8);
      const start = () => this.spawn(urls, count, mobile);
      if ('requestIdleCallback' in window) {
        requestIdleCallback(start, { timeout: 2000 });
      } else {
        setTimeout(start, 800);
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-paused', !entry.isIntersecting);
        });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    spawn(urls, count, mobile) {
      const offset = Math.floor(Math.random() * urls.length);
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < count; i++) {
        const size = mobile ? rand(16, 26) : rand(20, 36);
        const leaf = document.createElement('span');
        leaf.className = 'herbstlaub__leaf';
        leaf.style.setProperty('--x', `${rand(2, 96).toFixed(1)}%`);
        leaf.style.setProperty('--size', `${Math.round(size)}px`);
        leaf.style.setProperty('--fall', `${rand(9, 14).toFixed(1)}s`);
        leaf.style.setProperty('--delay', `${(i * rand(1.0, 1.6)).toFixed(1)}s`);
        leaf.style.setProperty('--drift', `${Math.round(rand(-12, 12))}vw`);
        leaf.style.setProperty('--sway', `${rand(2, 3.5).toFixed(1)}s`);
        leaf.style.setProperty('--spin', Math.random() < 0.5 ? '-1' : '1');

        const img = document.createElement('img');
        img.src = urls[(i + offset) % urls.length];
        img.alt = '';
        img.width = Math.round(size);
        img.height = Math.round(size);
        img.decoding = 'async';
        leaf.appendChild(img);
        fragment.appendChild(leaf);
      }
      this.appendChild(fragment);
    }
  }

  customElements.define('herbst-laub', HerbstLaub);
})();
